<template>
  <div>
    <b-modal
      id="cambiarVehiculoForm"
      size="lg"
      title="CAMBIAR VEHICULO"
      hide-footer
      no-close-on-esc
      @shown="onModalShown"
    >
      <div class="card">
        <div class="card-body">
          <div class="container-fluid h-100">
            <div class="row h-100">
              <form
                v-promise-btn="{ action: 'submit' }"
                @submit.prevent="validarForm"
              >
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-md-6 form-group form-group-md">
                      <div class="form-group">
                        <label for="nombre_cliente" class="label"
                          >Nombre de Cliente</label
                        >
                        <input
                          type="text"
                          class="form-control text-center bg-white"
                          disabled
                          name="Nombre del cliente"
                          id="nombre_cliente"
                          style="cursor: text"
                          v-model="nombreCliente"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6 form-group form-group-md">
                      <div class="form-group">
                        <label for="patente" class="label"
                          >Patente anterior</label
                        >
                        <input
                          id="patente"
                          v-model="patenteAnterior"
                          class="form-control text-center bg-white"
                          disabled
                          name="patente"
                          style="cursor: text"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6 form-group form-group-sm">
                      <label class="label" for="instalador">Instalador</label>
                      <SelectInstalador v-model="instalador" />
                    </div>

                    <div
                      class="col-12 col-md-6 form-group form-group-md d-flex align-items-end"
                    >
                      <label
                        class="form-check-label d-flex justify-content-start align-items-center"
                        for="instalarOtroDia"
                        style="cursor: pointer"
                      >
                        <input
                          id="instalarOtroDia"
                          v-model="instalarOtroDia"
                          class="form-check-inline"
                          style="zoom: 1.2; cursor: pointer"
                          type="checkbox"
                        />
                        Instalar otro dia
                      </label>
                    </div>

                    <template v-if="instalarOtroDia == 0">
                      <div class="col-12 form-group form-group-sm">
                        <label class="label" for="vehiculo"
                          >¿Qué quieres hacer con el avl</label
                        >
                        <template>
                          <div>
                            <label for="noCambiarAvl">
                              <input
                                type="radio"
                                id="noCambiarAvl"
                                :value="true"
                                v-model="noCambiarAvl"
                              />
                              Permanecer con el mismo</label
                            >
                          </div>
                          <div>
                            <label for="noCambiarAvl2">
                              <input
                                type="radio"
                                id="noCambiarAvl2"
                                :value="false"
                                v-model="noCambiarAvl"
                              />
                              Cambiar de AVL
                            </label>
                          </div>
                        </template>
                      </div>
                      <div class="container" v-if="noCambiarAvl == false">
                        <label class="label" for="">Datos de AVL NUEVO</label>
                        <div class="card container-fluid">
                          <div class="card-body">
                            <template>
                              <div class="row">
                                <div
                                  class="col-12 col-md-6 form-group form-group-md"
                                >
                                  <label class="label" for="avlChip"
                                    >AVL Chip</label
                                  >
                                  <SelectAvlChip v-model="idAvlAEnviar" />
                                </div>
                                <div
                                  class="col-12 col-md-6 form-group form-group-md"
                                >
                                  <div class="form-group">
                                    <label for="avlAnterior" class="label"
                                      >avl anterior</label
                                    >
                                    <input
                                      id="avlAnterior"
                                      v-model="idAvl"
                                      class="form-control text-center bg-white"
                                      disabled
                                      style="cursor: text"
                                      type="text"
                                    />
                                  </div>
                                </div>
                                <div class="col-12 form-group form-group-sm">
                                  <label
                                    class="label"
                                    for="comentarioTrazabilidad"
                                  >
                                    Comentario Trazabilidad
                                  </label>
                                  <textarea
                                    id="comentarioTrazabilidad"
                                    v-model="comentarioTrazabilidad"
                                    class="form-control text-center bg-white"
                                    cols="30"
                                    name="comentarioTrazabilidad"
                                    rows="3"
                                  ></textarea>
                                </div>

                                <div
                                  class="col-12 col-md-6 form-group form-group-sm"
                                >
                                  <label
                                    class="label form-check-label d-flex justify-content-start align-items-center"
                                    for="avlRoto"
                                    style="cursor: pointer"
                                  >
                                    <!-- v-model="estadoAVL" -->
                                    <!-- :value="false" -->
                                    <input
                                      id="avlRoto"
                                      class="form-check-inline"
                                      style="zoom: 1.2; cursor: pointer"
                                      :checked="estadoAVL === 'roto'"
                                      @change="
                                        estadoAVL =
                                          estadoAVL === 'roto' ? null : 'roto'
                                      "
                                      type="checkbox"
                                    />
                                    AVL ROTO
                                  </label>
                                </div>
                                <div
                                  class="col-12 col-md-6 form-group form-group-sm"
                                >
                                  <label
                                    class="label form-check-label d-flex justify-content-start align-items-center"
                                    for="avlRoto"
                                    style="cursor: pointer"
                                  >
                                    <!-- :value="false" -->
                                    <!-- v-model="estadoAVL" -->
                                    <input
                                      id="avlRoto"
                                      class="form-check-inline"
                                      style="zoom: 1.2; cursor: pointer"
                                      :checked="estadoAVL === 'extraviado'"
                                      @change="
                                        estadoAVL =
                                          estadoAVL === 'extraviado'
                                            ? null
                                            : 'extraviado'
                                      "
                                      type="checkbox"
                                    />
                                    AVL EXTRAVIADO
                                  </label>
                                </div>
                                <div
                                  v-if="estadoAVL"
                                  class="col-12 col-md-6 form-group form-group-md"
                                >
                                  <div class="form-group">
                                    <label for="costoCambioAVL" class="label"
                                      >Costo por el cambio</label
                                    >
                                    <input
                                      type="text"
                                      v-select-on-focus
                                      class="form-control"
                                      name="costo cambio Avl"
                                      id="costoCambioAVL"
                                      v-model="costoAVL"
                                    />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 form-group form-group-md">
                        <div class="form-group">
                          <label for="ubicacion_avl" class="label"
                            >Ubicación de avl</label
                          >
                          <textarea
                            type="text"
                            :class="`form-control text-center bg-white`"
                            name="ubicacion de avl"
                            id="ubicacion_avl"
                            style="cursor: text"
                            v-model="ubicacionAvl"
                          />
                        </div>
                      </div>
                      <SelectVehiculo v-model="vehiculo" />
                      <ViaticosForm v-model="viaticos" ref="viaticosForm" />

                      <div class="col-12 form-group form-group-sm">
                        <label class="label" for="vehiculo"
                          >Grupos / Accesos</label
                        >
                        <div class="card">
                          <div class="card-body">
                            <template>
                              <div>
                                <label for="gruposYAccesos">
                                  <input
                                    type="radio"
                                    id="gruposYAccesos"
                                    :value="true"
                                    v-model="mantenerAccesosYGrupos"
                                  />
                                  Si</label
                                >
                              </div>
                              <div>
                                <label for="gruposYAccesos2">
                                  <input
                                    type="radio"
                                    id="gruposYAccesos2"
                                    :value="false"
                                    v-model="mantenerAccesosYGrupos"
                                  />
                                  No
                                </label>
                              </div>
                            </template>
                            <small style="fontsize: small; color: gray"
                              >*Conservar grupos y accesos del vehículo
                              anterior</small
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 form-group form-group-sm">
                        <label
                          class="label form-check-label"
                          for="instalacionEnTaller"
                          style="cursor: pointer"
                        >
                          <input
                            id="instalacionEnTaller"
                            v-model="taller"
                            class="form-check-inline"
                            style="zoom: 1.2; cursor: pointer"
                            type="checkbox"
                          />
                          Instalación en taller
                        </label>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="w-100 d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="$bvModal.hide('cambiarVehiculoForm')"
                  >
                    Cancelar
                  </button>
                  <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="CambiarVehiculoCaptchaModal"
      size="md"
      title="¡Atención! Verificación Requerida"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="warning"
      header-text-variant="dark"
      body-bg-variant="light"
      header-border-variant="warning"
    >
      <template>
        <div class="d-flex align-items-center w-100"></div>
      </template>

      <div class="captcha-container border-left border-warning pl-3">
        <p class="text-center mb-3 font-weight-bold text-dark">
          <i class="fas fa-shield-alt mr-1"></i>
          Para confirmar el cambio de vehiculo con un AVL que no está
          reportando, por favor resuelva la siguiente operación:
        </p>

        <MathCaptcha v-model="isCaptchaValid" />

        <div class="alert alert-warning small mt-3">
          <i class="fas fa-info-circle"></i>
          Esta verificación es necesaria para operaciones sensibles que
          involucran dispositivos que no están reportando.
        </div>

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="cancelarCaptcha">
            <i class="fas fa-times mr-1"></i> Cancelar
          </button>
          <button
            class="btn btn-warning text-dark font-weight-bold"
            @click="submit"
          >
            <i class="fas fa-check mr-1"></i> Confirmar cambio de vehículo
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import SelectInstalador from "../../Commons/SelectInstalador.vue";
import NombreCliente from "../../../shared/NombreCliente";
import SelectVehiculo from "../../Commons/SelectVehiculo.vue";
import { get, isNull } from "lodash-es";
import axios from "axios";
import MathCaptcha from "../../../shared/MathCaptcha.vue";
import SelectAvlChip from "../../Commons/SelectAvlChip.vue";
import ViaticosForm from "../../../../../components/Viaticos/ViaticosForm.vue";

export default {
  name: "cambiar-vehiculo",
  mounted() {
    this.getNombreCliente(this.$route.params.id_cliente);
  },
  mixins: [NombreCliente],
  components: {
    SelectInstalador,
    SelectVehiculo,
    MathCaptcha,
    SelectAvlChip,
    ViaticosForm,
  },
  data: () => ({
    isDirty: false,
    instalarOtroDia: false,
    ubicacionAvl: "",
    taller: false,
    vehiculo: null,
    instalador: null,
    mantenerAccesosYGrupos: true,
    isCaptchaValid: false,
    mostrarCaptcha: false,
    noCambiarAvl: true,
    comentarioTrazabilidad: "",
    estadoAVL: null,
    costoAVL: 0,
    idAvlAEnviar: null,
    avlChipKey: 0,
    preloadAvlId: null,
    viaticos: {
      viaticosCliente: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
      viaticosInstalador: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
    },
  }),
  methods: {
    async ultimoReporteYEstado() {
      if (this.instalarOtroDia) {
        await this.submit();
        return;
      }
      try {
        const avlId = this.noCambiarAvl ? this.idAvl : this.idAvlAEnviar.id_avl;

        if (!avlId) {
          this.$msgBoxOk("Error: No se pudo obtener el ID del AVL");
          return;
        }
        const resp = await axios.post("/execute", {
          method: "CLI.GetTiempoUltimoReporteYEstadoAVL",
          parameters: [{ name: "id_avl", value: avlId }],
        });
        if (resp.data.ok) {
          if (resp.data.result[0][0].esta_reportando === 0) {
            const dataMinutos =
              resp.data.result[0][0].minutos_desde_ultimo_reporte;
            let tiempoReporte = "";

            if (dataMinutos > 60) {
              const horasUltimoReporte = Math.floor(dataMinutos / 60);
              const minutosDeHorasUltimoReporte = Math.floor(dataMinutos % 60);

              tiempoReporte = `${horasUltimoReporte} horas y ${minutosDeHorasUltimoReporte} minutos`;
            } else {
              tiempoReporte = `${dataMinutos} minutos`;
            }

            try {
              const mensaje = this.$createElement("div", [
                this.$createElement(
                  "p",
                  "¡Ojo! Señal de satélites desactualizada!",
                ),
                this.$createElement(
                  "p",
                  `El último reporte con señal satelital fue hace ${tiempoReporte}`,
                ),
                this.$createElement("p", "¿Está seguro que desea continuar?"),
              ]);

              const respuestaMensaje = await this.$bvModal.msgBoxConfirm(
                mensaje,
                {
                  title: "Advertencia",
                  size: "md",
                  buttonSize: "sm",
                  okVariant: "danger",
                  okTitle: "Sí, continuar",
                  cancelVariant: "secondary",
                  cancelTitle: "No, cancelar",
                  footerClass: "p-2",
                  hideHeaderClose: false,
                  centered: true,
                  headerBgVariant: "warning",
                  headerTextVariant: "dark",
                },
              );

              if (respuestaMensaje) {
                this.mostrarCaptcha = true;
                this.$bvModal.show("CambiarVehiculoCaptchaModal");
              } else {
                this.mostrarCaptcha = false;
              }
            } catch (modalError) {
              this.mostrarCaptcha = false;
              this.$msgBoxOk("Error en la confirmación de cambio de vehículo", {
                title: "Error",
              });
            }
          } else {
            await this.submit();
          }
        } else {
          await this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        this.$msgBoxOk("Error al verificar el estado del AVL: " + error);
        this.mostrarCaptcha = false;
      }
    },
    onModalShown() {
      this.vehiculo = null;
      this.instalarOtroDia = false;
      this.ubicacionAvl = "";
      this.taller = false;
      this.instalador = null;
      this.isCaptchaValid = false;
      this.isDirty = false;
      this.mostrarCaptcha = false;
      this.idAvlAEnviar = null;
      this.noCambiarAvl = true;
      this.comentarioTrazabilidad = null;
      this.estadoAVL = null;
      this.costoAVL = 0;
      this.viaticos = {
        viaticosCliente: {
          activo: false,
          combustible: { activo: false, kilometros: 0, descripcion: "" },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: { activo: false, kilometros: 0, descripcion: "" },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
    },
    cancelarCaptcha() {
      this.$bvModal.hide("CambiarVehiculoCaptchaModal");
      this.mostrarCaptcha = false;
      this.isCaptchaValid = false;
    },
    async validarForm() {
      this.isDirty = true;

      if (!this.instalador) {
        this.$msgBoxOk("Por favor, elija un instalador");
        return;
      }
      if (!this.instalarOtroDia) {
        const mensaje = [];
        if (isNull(this.vehiculo)) {
          mensaje.push("Por favor, elija un vehículo");
        }
        if (!this.ubicacionAvl) {
          mensaje.push("Por favor, coloque una ubicación del avl");
        }
        if (!this.noCambiarAvl) {
          if (!this.idAvlAEnviar) {
            mensaje.push("Por favor, seleccione un AVL para el reemplazo");
          }

          if (
            !this.comentarioTrazabilidad ||
            !this.comentarioTrazabilidad.trim()
          ) {
            mensaje.push("Por favor, ingrese un comentario de trazabilidad");
          }

          //si se marca como roto o extraviado, debe tener un costo
          if (
            (this.estadoAVL === "roto" || this.estadoAVL === "extraviado") &&
            (!this.costoAVL || this.costoAVL === 0)
          ) {
            mensaje.push(
              "Por favor, ingrese el costo del AVL " + this.estadoAVL,
            );
          }
        }

        if (this.$refs.viaticosForm) {
          const viaticosErrors = this.$refs.viaticosForm.validateForm();
          if (viaticosErrors.length > 0) {
            mensaje.push(...viaticosErrors);
          }
        }

        if (mensaje.length) {
          this.$msgBoxOk(
            mensaje.map((msj) => this.$createElement("p", msj)),
            {
              title: this.$createElement("h4", "Controlar formulario"),
            },
          );
          return;
        }
      }
      if (this.idAvl === null || this.idAvl === undefined) {
        await this.$msgBoxOk("Ups, algo salio mal. Avl no encontrado");
        return;
      }

      await this.ultimoReporteYEstado();
    },
    async submit() {
      if (this.mostrarCaptcha && !this.isCaptchaValid) {
        return;
      }

      if (this.mostrarCaptcha) {
        this.$bvModal.hide("CambiarVehiculoCaptchaModal");
      }

      try {
        const viaticosFormateados = this.$refs.viaticosForm
          ? this.$refs.viaticosForm.getFormattedViaticos()
          : this.viaticos;

        const resp = await axios.post("/execute", {
          method: "CLI.CambiarVehiculo",
          parameters: [
            { name: "id_cliente_", value: this.$route.params.id_cliente },
            { name: "patente_anterior", value: this.patenteAnterior },
            {
              name: "id_instalador",
              value: this.instalador.id_instaladores,
            },
            {
              name: "para_instalar_otro_dia",
              value: this.instalarOtroDia ? 1 : 0,
            },
            { name: "ubicacion_avl", value: this.ubicacionAvl },
            {
              name: "id_vehiculo_nuevo",
              value: this.instalarOtroDia
                ? null
                : get(this.vehiculo, "id_vehiculo", "error"),
            },
            {
              name: "mantenerAccesosyGruposDelVehiculoAnterior",
              value: this.mantenerAccesosYGrupos ? 1 : 0,
            },

            { name: "taller", value: this.taller ? 1 : 0 },
            { name: "cambiar_avl", value: !this.noCambiarAvl ? 1 : 0 },
            {
              name: "id_avl_nuevo",
              value: !this.noCambiarAvl ? this.idAvlAEnviar.id_avl : null,
            },
            {
              name: "comentario_trazabilidad",
              value: !this.noCambiarAvl ? this.comentarioTrazabilidad : null,
            },
            { name: "avl_roto", value: this.estadoAVL === "roto" ? 1 : 0 },
            {
              name: "avl_extraviado",
              value: this.estadoAVL === "extraviado" ? 1 : 0,
            },
            { name: "costo_avl_cliente", value: this.costoAVL || 0 },
            {
              name: "viaticos_cliente_activo",
              value: viaticosFormateados.viaticosCliente.activo ? 1 : 0,
            },
            {
              name: "viaticos_cliente_combustible_activo",
              value: viaticosFormateados.viaticosCliente.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_combustible_kilometros",
              value: viaticosFormateados.viaticosCliente.combustible.kilometros,
            },
            {
              name: "viaticos_cliente_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosCliente.combustible.montoCalculado,
            },
            {
              name: "viaticos_cliente_combustible_descripcion",
              value:
                viaticosFormateados.viaticosCliente.combustible.descripcion,
            },
            {
              name: "viaticos_cliente_adicional_activo",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_adicional_monto",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.monto,
            },
            {
              name: "viaticos_cliente_adicional_descripcion",
              value:
                viaticosFormateados.viaticosCliente.viaticoAdicional
                  .descripcion,
            },
            {
              name: "viaticos_instalador_activo",
              value: viaticosFormateados.viaticosInstalador.activo ? 1 : 0,
            },
            {
              name: "viaticos_instalador_combustible_activo",
              value: viaticosFormateados.viaticosInstalador.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_combustible_kilometros",
              value:
                viaticosFormateados.viaticosInstalador.combustible.kilometros,
            },
            {
              name: "viaticos_instalador_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosInstalador.combustible
                  .montoCalculado,
            },
            {
              name: "viaticos_instalador_combustible_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.combustible.descripcion,
            },
            {
              name: "viaticos_instalador_adicional_activo",
              value: viaticosFormateados.viaticosInstalador.viaticoAdicional
                .activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_adicional_monto",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional.monto,
            },
            {
              name: "viaticos_instalador_adicional_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional
                  .descripcion,
            },
          ],
        });
        let mjeExito = `Cambio de vehículo  del cliente ${this.nombreCliente} realizados con éxito`;
        if (resp.data.ok) {
          await this.$msgBoxOk(mjeExito).then(() => {
            this.$emit("update");
            this.$bvModal.hide("cambiarVehiculoForm");
            this.mantenerAccesosYGrupos = true;
          });
        } else {
          const mjeMantenimiento =
            "Ojo que está en mantenimiento ese vehículo!";

          const mjeData = get(resp.data, "message", false);
          await this.$msgBoxOk(mjeData || mjeMantenimiento).then(() => {
            if (
              mjeData.includes(mjeMantenimiento) ||
              this.instalarOtroDia == 1
            ) {
              if (this.instalarOtroDia == 1) {
                this.$msgBoxOk(`Cambios realizados con éxito`);
              } else {
                this.$msgBoxOk(mjeExito);
              }
              this.$emit("update");
              this.$bvModal.hide("cambiarVehiculoForm");
            }
          });
        }
      } catch (e) {
        console.error(e);
        try {
          await this.$msgBoxOk("Ha ocurrido un error al cambiar el vehículo", {
            title: this.$createElement("h4", "Error"),
          });
        } catch (modalError) {
          console.warn("Error al mostrar mensaje: ", modalError);
        }
      }
    },
  },
  computed: {
    patenteAnterior: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.patenteAnterior;
      },
    },
    idAvl: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.avl;
      },
    },
  },
  watch: {
    instalarOtroDia(newValue) {
      if (newValue) {
        this.mantenerAccesosYGrupos = true;
        this.vehiculo = null;
        this.ubicacionAvl = "";
        this.taller = false;
        this.isCaptchaValid = false;
        this.isDirty = false;
        this.mostrarCaptcha = false;
        this.idAvlAEnviar = null;
        this.noCambiarAvl = true;
        this.comentarioTrazabilidad = "";
        this.estadoAVL = null;
        this.costoAVL = 0;
        this.viaticos = {
          viaticosCliente: {
            activo: false,
            combustible: { activo: false, kilometros: 0, descripcion: "" },
            viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
          },
          viaticosInstalador: {
            activo: false,
            combustible: { activo: false, kilometros: 0, descripcion: "" },
            viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
          },
        };
      }
    },
    noCambiarAvl(newValue) {
      if (newValue === true) {
        this.idAvlAEnviar = null;
        this.comentarioTrazabilidad = "";
        this.estadoAVL = null;
        this.costoAVL = 0;
      }
    },
    estadoAVL(newValue) {
      if (newValue === null) {
        this.costoAVL = 0;
      }
    },
  },
};
</script>
<style scoped>
.captcha-container {
  padding: 1rem;
}
</style>
